import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, ModalDialog, inEmbedMode } from "../../odc-ui";
import SquareCardForm from "./square_card_form";

const AddSquareCardModal = ({
  renderTrigger,
  onSquareCardFormSuccess,
  theme,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleSquareCardFormSuccess = () => {
    setShowModal(false);
    if (onSquareCardFormSuccess) {
      onSquareCardFormSuccess();
    }
  };

  return (
    <>
      {renderTrigger ? (
        renderTrigger(setShowModal)
      ) : (
        <Button
          onClick={(e) => {
            e.preventDefault();
            setShowModal(true);
          }}
          type={
            inEmbedMode()
              ? "embed"
              : theme === "paige"
              ? "primary-paige"
              : "primary"
          }
        >
          Add New Card
        </Button>
      )}

      {showModal && (
        <ModalDialog
          modalDialogClassName="component-add-square-card-modal"
          maxWidth={600}
          marginTop={100}
        >
          <h2>Add New Card</h2>
          <SquareCardForm
            onSuccess={handleSquareCardFormSuccess}
            onCancelClick={(e) => {
              e.preventDefault();
              setShowModal(false);
            }}
            theme={theme}
          />
        </ModalDialog>
      )}
    </>
  );
};

AddSquareCardModal.propTypes = {
  renderTrigger: PropTypes.func,
  onSquareCardFormSuccess: PropTypes.func,
  theme: PropTypes.string,
};

export default AddSquareCardModal;
